import {FC} from 'react'
import {MembershipPage} from './MembershipPage'

const MembershipPageWrapper: FC = () => {
  return <MembershipPage />
}

export default MembershipPageWrapper
